import {getEditableFieldConfiguration} from "../editable-field.component";
import {IEditableField} from "../IEditableField";

export class NumberEditableFieldComponent extends IEditableField{
    static instance = getEditableFieldConfiguration(
        require('./number-editable-field.component.html'),
        NumberEditableFieldComponent
    )
}